import React from "react";
import { ToastContainer } from "react-toastify";
import { AddCareer } from "../../components/Career/AddCareer";

export const CareerAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddCareer />
        </div>
      </div>
    </div>
  );
};
